<!-- eslint-disable -->
<template lang="pug">
    .loader-container
        svg-icon.cs-loader(name="loader", :size="size")
</template>

<script>
    /*eslint-disable*/
    /**
     * Loader is shown instead of loading content
     * If you need change default size, please use special class on loader
     * `<loader class="block__loader" />`
     */
    export default {
        name: "CsLoader",
        status: "ready",
        release: "1.0.0",
        props: {
            /**
             * The size of the loader.
             * `small, base, large`
             */
            size: {
                type: String,
                default: "xxx-large",
                validator: value => value.match(/(small|base|xxx-large)/)
            },
        }
    }
</script>

<style lang="scss" scoped>
    .loader-container {
        width: 100%;
        display: flex;
        align-items: center;
        justify-content: center;
        border-radius: $border-radius-circle;
    }
    .cs-loader {
        animation: spin 2s linear infinite;
        margin: 50px auto;
    }
    @keyframes spin {
        100% {
            transform: rotate(360deg);
        }
    }
</style>
